import { Button } from "react-bootstrap";
import NoContent from "../components/common/NoContent";
import { TREND } from "../constants";
import { Organization } from "../models/Organization";
import { format, parseISO } from "date-fns";
import { isEmpty } from "lodash";

export function renderValue(val) {
	return <div>{val}</div>
}

/**
 * Renders the viewable date-range bar. Use filled on driver/user detail views
 * (no group picker); leave outline on manager home where the group selector is primary.
 */
export function renderPeriod(organization?:Organization, options?: { filled?: boolean }) {
	if(organization) {
		let viewWindow = ""

		if (organization?.startViewableWindow) {
			viewWindow = format(parseISO(organization?.startViewableWindow.toString()), 'MMM do')
		}

		if (organization?.endViewableWindow) {
			viewWindow = `${viewWindow} - ${format(parseISO(organization?.endViewableWindow.toString()), 'MMM do')}`
		}

		const dateBarClassName = options?.filled
			? "card app-date-bar app-date-bar--filled"
			: "card app-date-bar"

		return (
			<div className="row" >
				<div className="col-12 align-items-center">
					<div className={dateBarClassName} style={{padding: "0.35rem"}}>
						<div className="card-body align-items-center app-page-text" style={{padding: "0.35rem"}}>
							<div className="text-center fw-bold app-date-bar-text">
								{viewWindow}
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export function displayAcknowledgeDate(date?: Date|string) {
	const dateFormat = "MMMM dd, yyyy"
	const timeFormat = "hh:mm a"
	if (date) {
		if (date instanceof Date) {
			return `${format(date, dateFormat)} at ${format(date, timeFormat)}`
		} else {
			const realDate = parseISO(date.toString())
			return `${format(realDate, dateFormat)} at ${format(realDate, timeFormat)}`
		}
	} else {
		return undefined
	}
}

export function displayDate(date?: Date|string) {
	const dateFormat = "MM/dd/yy"
	if (date) {
		if (date instanceof Date) {
			return `${format(date, dateFormat)}`
		} else {
			const realDate = parseISO(date.toString())
			return `${format(realDate, dateFormat)}`
		}
	} else {
		return undefined
	}
}

export function getTrendClass(trend?:string, modifer?:string) {
	
	var trendClass = `fa-solid fa-arrows-h ${modifer} icn-orange mt-0`
	switch (trend) {
		case TREND.DOWN:
			trendClass = `fa-solid fa-arrow-down ${modifer} icn-red mt-0`
			break;
		case TREND.UP:
			trendClass = `fa-solid fa-arrow-up ${modifer} icn-green mt-0`
			break;
		case TREND.NO_CHANGE:
			trendClass = `fa-solid fa-arrows-h ${modifer} icn-orange mt-0`
			break;
		case TREND.NOT_APPLICABLE:
			trendClass = ``
			break;
		default:
			break;
	}

	return trendClass
}

export const NoContentWrapper = ({items, message, showIcon, ...props}) =>{
	if (isEmpty(items)) {
		return <NoContent message={message} showIcon={showIcon}/>
	} else {
		return props.children
	}
}

/**
 * Renders the PWA install prompt banner. Layout is theme-agnostic (centered text + button).
 * Callers should place this inside a Bootstrap row (and container when not already wrapped).
 * After prompting, clears the one-shot BeforeInstallPromptEvent and notifies the caller.
 */
export function renderBannerInstall(deferredPrompt, onPromptHandled?: () => void) {
	/**
	 * Shows the browser install prompt once, then clears the saved event.
	 */
	async function handleInstallClick() {
		const promptEvent = deferredPrompt?.current;
		if (!promptEvent)
		{
			return;
		}

		try
		{
			await promptEvent.prompt();
			if (promptEvent.userChoice)
			{
				await promptEvent.userChoice;
			}
		}
		catch
		{
			// Prompt may reject if already consumed; still clear so the banner can hide.
		}
		finally
		{
			if (deferredPrompt)
			{
				deferredPrompt.current = null;
			}
			if (onPromptHandled)
			{
				onPromptHandled();
			}
		}
	}

	return (
		<div className="col col-12">
			<div className="card">
				<div className="card-body app-install-banner app-page-text">
					<p className="app-install-banner-text">Driver Score works best if installed on the device</p>
					<Button
						variant="primary"
						size="lg"
						className="app-install-banner-button"
						onClick={handleInstallClick}
					>
						Install
					</Button>
				</div>
			</div>
		</div>
	)
}

export const isIos = () => {
	const userAgent = window.navigator.userAgent.toLowerCase();
	//console.log('userAgent = ', userAgent)
	return /iphone|ipad|ipod/.test( userAgent );
  }

export function renderIOSBannerInstall() {

	  // Detects if device is in standalone mode
	  const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

	if (isIos() && !isInStandaloneMode()) {
		return (
			<div className="col col-12">
				<div className="card">
					<div className="card-body app-install-banner app-page-text">
						<p className="app-install-banner-text">Install Driver Score on your iOS device.  Tap the &nbsp; <i className="fa-solid fa-arrow-up-from-bracket" /> &nbsp; and select &nbsp; <i className="fa-regular fa-square-plus" /> &nbsp;Add to Home Screen</p>
					</div>
				</div>
			</div>
		)
	}  
	
}